module.exports = __webpack_public_path__ + "media/images/icons/search-e6a37ba4532c1f23025562708dce627b.svg";